import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { NavbarSidebarComponent } from './navbar-sidebar.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxAccordionModule, DxHtmlEditorModule, DxTabPanelModule, DxTagBoxModule, DxTextAreaModule, DxPopupModule,DxCheckBoxModule, DxDropDownBoxModule, DxToolbarModule, DxButtonModule, DxActionSheetModule,DxListModule, DxPopoverModule, DxTemplateModule, DxAutocompleteModule, DxTextBoxModule, DxTooltipModule, DxScrollViewModule, DxSelectBoxModule, DxDataGridModule, DxDateBoxModule, DxRadioGroupModule, DxNumberBoxModule, DxDropDownButtonModule, DxTileViewModule, DxTreeViewModule, DxTreeListModule, DxGalleryModule} from "devextreme-angular";

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { CreateUpdateTaskModule } from '../create-update-task/create-update-task.module';
import { NewEmpleoyeActivitiesModule } from 'src/app/pages/sales-management/employee-activities/forms/new-empleoye-activities/new-empleoye-activities.module';
import { NewCustomerModule } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.module';
import { CreateUpdateSalesProjectModule } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.module';
import { NewContactModule } from '../new-contact/new-contact.module';
import { ServicesMapModule } from 'src/app/pages/service-management/services-map/map-service/services-map.module';
import { NewServiceWorkOrderModule } from 'src/app/pages/service-management/services-map/components/new-service-work-order/new-service-work-order.module';
import { NewRfiModule } from 'src/app/pages/project-management/edit-project/new-rfi/new-rfi.module';
import { NewPushListItemModule } from 'src/app/pages/project-management/edit-project/new-push-list-item/new-push-list-item.module';
import { NewProgressReportModule } from 'src/app/pages/project-management/edit-project/new-progress-report/new-progress-report.module';
import { AlarmWorkFlowSummaryModule } from 'src/app/pages/project-management/alarm-work-flow-summary/alarm-work-flow-summary.module';
import { AlarmCustomersModule } from 'src/app/pages/sales-management/alarm-customers/alarm-customers.module';
import { NewSalesLeadModule } from 'src/app/pages/sales-management/sales-leads/modals/new-sales-lead/new-sales-lead.module';
import { SimpleViewCommissioningModule } from 'src/app/pages/simpleView/simple-view-commissioning/simple-view-commissioning.module';
import { TreeviewAreaSystemModule } from '../treeview-area-system/treeview-area-system.module';
import { ApplicationsComponent } from 'src/app/pages/shop/applications/applications.component';
import { ApplicationsModule } from 'src/app/pages/shop/applications/applications.module';

@NgModule({
  declarations: [
    NavbarSidebarComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTabPanelModule,
    DxCheckBoxModule,
    DxDropDownBoxModule,
    DxToolbarModule,
    DxButtonModule,
    DxActionSheetModule,
    DxListModule,
    DxPopoverModule,
    DxTemplateModule,
    DxAutocompleteModule,
    GooglePlaceModule,
    DxTextBoxModule,
    DxPopupModule,
    DxTooltipModule,
    CreateUpdateTaskModule,
    NewEmpleoyeActivitiesModule,
    NewCustomerModule,
    DxScrollViewModule,
    CreateUpdateSalesProjectModule,
    NewContactModule,
    NewServiceWorkOrderModule,
    NewRfiModule,
    NewPushListItemModule,
    NewProgressReportModule,
    DxSelectBoxModule,
    DxDataGridModule,
    AlarmWorkFlowSummaryModule,
    AlarmCustomersModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxHtmlEditorModule,
    DxAccordionModule,
    NewSalesLeadModule,
    SimpleViewCommissioningModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    TreeviewAreaSystemModule,
    DxNumberBoxModule,
    DxDropDownButtonModule,
    DxTileViewModule,
    DxTreeViewModule,
    DxRadioGroupModule,
    DxTreeListModule,
    DxGalleryModule,
    DxTileViewModule,
    ApplicationsModule,
    // NewRFIModule
  ],
  exports: [NavbarSidebarComponent],
  // entryComponents:[ApplicationsComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class NavbarSidebarModule { }
